import cn from 'classnames'
import React, { ComponentProps, useId } from 'react'

type XCircleFilledIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function XCircleFilledIcon(props: XCircleFilledIconProps) {
  const { className = '', ...rest } = props
  const clipId = useId()
  return (
    <svg
      className={cn('XCircleFilledIcon', className)}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...rest}
    >
      <g clipPath={`url(#${clipId})`}>
        <path
          d="M10 19.091C15.0208 19.091 19.0909 15.0209 19.0909 10.0001C19.0909 4.97932 15.0208 0.90918 10 0.90918C4.97923 0.90918 0.909088 4.97932 0.909088 10.0001C0.909088 15.0209 4.97923 19.091 10 19.091Z"
          fill="#D5404A"
        />
        <path
          d="M12.7273 7.27282L7.27272 12.7274M7.27272 7.27282L12.7273 12.7274M19.0909 10.0001C19.0909 15.0209 15.0208 19.091 10 19.091C4.97923 19.091 0.909088 15.0209 0.909088 10.0001C0.909088 4.97932 4.97923 0.90918 10 0.90918C15.0208 0.90918 19.0909 4.97932 19.0909 10.0001Z"
          stroke="white"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
